import { createSlice } from '@reduxjs/toolkit';
import constClass from '../Constants/Constants';

// Stateの初期状態
const initialState = {
  shop: '',
  plan: '0',
  receiveDate: null,
  selectReceiveDate: null,
  status: [constClass.STATUS.REG, constClass.STATUS.PRE, constClass.STATUS.FIN, constClass.STATUS.DFIN],
  selectStatus: [
    { value: constClass.STATUS.REG, label: constClass.STATUS_NAME.REG },
    { value: constClass.STATUS.PRE, label: constClass.STATUS_NAME.PRE },
    { value: constClass.STATUS.FIN, label: constClass.STATUS_NAME.FIN },
    { value: constClass.STATUS.DFIN, label: constClass.STATUS_NAME.DFIN }
  ],
  isReload: true,
  shopMaster: [],
  planMaster: [],
  productMaster: [],
  sortOrder: [],
  index: 1,
  initFlag: false,
};

const BackyardOrderCondition = createSlice({
  name: "BackyardOrderCondition",
  initialState: initialState,
  reducers: {
    setShop: (state, action) => ({
      ...state,
      shop: action.payload,
      isReload: true,
    }),
    setPlan: (state, action) => ({
      ...state,
      plan: action.payload,
      isReload: true,
    }),
    setSelectReceiveDate: (state, action) => ({
      ...state,
      receiveDate: action.payload ? action.payload.map((item) => item.value) : null,
      selectReceiveDate: action.payload,
      isReload: true,
    }),
    setSelectStatus: (state, action) => ({
      ...state,
      status: action.payload ? action.payload.map((item) => item.value) : null,
      selectStatus: action.payload,
      isReload: true,
    }),
    setIsReload: (state, action) => ({
      ...state,
      isReload: action.payload,
    }),
    setShopMaster: (state, action) => ({
      ...state,
      shopMaster: action.payload,
    }),
    setPlanMaster: (state, action) => ({
      ...state,
      planMaster: action.payload,
    }),
    setProductMaster: (state, action) => ({
      ...state,
      productMaster: action.payload,
    }),
    setInitFlag: (state) => ({
      ...state,
      initFlag: true,
    }),
    setSortOrder: (state, action) => ({
      ...state,
      sortOrder: action.payload,
    }),
    setIndex: (state, action) => ({
      ...state,
      index: action.payload,
      sortOrder: [],
      isReload: true,
    }),
    logout: (state) => ({
      ...initialState,
    })
  }
});

// 個別でも使えるようにActionCreatorsをエクスポートしておく
export const { setShop, setPlan, setSelectReceiveDate, setSelectStatus, setIsReload, setShopMaster, setPlanMaster, setProductMaster, setInitFlag, logout } = BackyardOrderCondition.actions;

export default BackyardOrderCondition;